const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export { API };

const ERROR_MESSAGES = {
  401: "Email o password non validi",
  403: "Accesso negato",
  404: "Risorsa non trovata",
  409: "Email già registrata. Prova ad accedere oppure usa 'Password dimenticata?' se non ricordi la password.",
  422: "Dati non validi",
  500: "Errore del server",
};

const handleResponse = async (res) => {
  if (!res.ok) {
    let msg = "";
    let detail = null;
    try {
      const text = await res.text();
      if (text) {
        try {
          const j = JSON.parse(text);
          detail = j.detail;
          // detail can be a string OR an object (structured error)
          if (typeof detail === "string") msg = detail;
          else if (detail && typeof detail === "object" && detail.message) msg = detail.message;
        } catch {
          msg = text;
        }
      }
    } catch {
      // body consumed by external script - use status-based message
    }
    if (!msg) msg = ERROR_MESSAGES[res.status] || `Errore HTTP ${res.status}`;

    // Structured trial limit errors → dispatch a global event so a modal can show.
    let isTrialLimit = false;
    if (
      res.status === 403 &&
      detail && typeof detail === "object" &&
      typeof detail.code === "string" && detail.code.startsWith("TRIAL_LIMIT_")
    ) {
      isTrialLimit = true;
      try {
        // Suppress local component toasts for ~1.5s while the modal is showing.
        window.__tabelloneSuppressToastUntil = Date.now() + 1500;
        window.dispatchEvent(new CustomEvent("trial-limit-reached", { detail }));
      } catch { /* SSR safety */ }
    }

    const err = new Error(String(msg));
    err.status = res.status;
    err.detail = detail;
    err.isTrialLimit = isTrialLimit;
    throw err;
  }
  return res.json().catch(() => ({}));
};

const safeFetch = async (url, options) => {
  try {
    return await fetch(url, options);
  } catch (e) {
    throw new Error(typeof e?.message === "string" ? e.message : "Errore di connessione");
  }
};

export const api = {
  get: (url) =>
    safeFetch(`${API}${url}`, { credentials: "include" }).then(handleResponse),

  post: (url, data) =>
    safeFetch(`${API}${url}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      credentials: "include",
    }).then(handleResponse),

  put: (url, data) =>
    safeFetch(`${API}${url}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      credentials: "include",
    }).then(handleResponse),

  del: (url, body) =>
    safeFetch(`${API}${url}`, {
      method: "DELETE",
      credentials: "include",
      ...(body !== undefined ? {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      } : {}),
    }).then(handleResponse),
};
